import { Injectable } from '@angular/core';
import { Customer } from '../model/customer';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { Api } from '../enum/Api';
import { CheckoutSuccessData } from '../model/checkout-success-data';
import { map } from 'rxjs/operators';

@Injectable()
export class CustomerService {
  currentCustomerdata: Customer;
  CHECK_AND_VALIDATE = 'serasa/pmeSaleConfig/checkAndValidate';

  constructor(private httpService: HttpService) { }

  public setCurrentCustomer(customer) {
    this.currentCustomerdata = customer;
    this.saveCustomerOnSessionStorage();
  }

  public getCurrentCustomer(): Customer {
    return this.currentCustomerdata;
  }

  public saveCustomerOnSessionStorage() {
    sessionStorage.setItem('customer', JSON.stringify(this.currentCustomerdata)
    );
  }

  public getCustomerOnSessionStorage() {
    this.setCurrentCustomer(
      new Customer(JSON.parse(sessionStorage.getItem('customer')))
    );
  }

  public getUserAccountUserData(userId: string): Observable<any> {
    return this.httpService.post(
      'integration/digitalCommerce/getUserAccountUserData',
      Api.One_Portal,
      { 'userId': userId }
    );
  }

  public getTelevendasData(validationToken: string): Observable<any> {
    return this.httpService.post(
      'eCommercePME/eCommerceAPI/getTelevendasData',
      Api.One_Portal,
      {
        'validationToken': validationToken
      }
    )
  }

  public getBusinessAccountData(businessId: string, productClassification: string, notLogged: boolean): Observable<any> {
    return this.httpService.post(
      'integration/digitalCommerce/getBusinessAccountData',
      Api.One_Portal,
      { 'businessId': businessId, 
        'productClassification': productClassification,
        'notLogged': notLogged
      }
    );
  }

  public getMitigationData(cnpj: string, productClassification: string): Observable<any> {
    return this.httpService.post(
      this.CHECK_AND_VALIDATE,
      Api.One_Portal,
      {
        'identifier': 'mitigationFilter',
        'productClassification': productClassification,
        'cnpj': cnpj
      });
  }

  public checkIfAlreadyPurchased(businessId: string, userId: string, productClassification: string, product: string ): Observable<CheckoutSuccessData> {
    return this.httpService.post(
      'eCommercePME/eCommerceAPI/checkIfAlreadyPurchased',
      Api.One_Portal,
      { 'businessId': businessId, 'userId': userId, 'productClassification': productClassification, 'product': product}
    ).pipe(map(result => new CheckoutSuccessData(result)));
  }

  public getAccountData(businessId: string, userId: string, classification: string, validatedMitigation: boolean, timeStamp: string): Observable<any> {
    return this.httpService.post(
      'integration/digitalCommerce/getAccountData',
      Api.One_Portal,
      {
        'businessId': businessId,
        'userId': userId,
        'productClassification': classification,
        'validatedMitigation': validatedMitigation,
        'timeStamp': timeStamp
      }
    );
  }

  // TODO - Ocultar razão social
  // TODO - Mudar Data de Aniversário para DD/MM/YYYY
  // TODO -
  public validateIdentity(customerData: Customer, classification: string) {
    return this.httpService.post(
      this.CHECK_AND_VALIDATE,
      Api.One_Portal,
      {
        'identifier': 'identityValidator',
        'productClassification': classification,
        'customerData': customerData
      });
  }

  // public registerUser(customerData: Customer) {
  //   return this.httpService.post('integration/digitalCommerce/registerUser',
  //     Api.One_Portal, {
  //     'customerData': customerData
  //   });
  // }

  public registerUser(customerData: Customer, classification: string, product?: string, coupon?: string) {
    return this.httpService.post(
      this.CHECK_AND_VALIDATE,
      Api.One_Portal,
      {
        'identifier': 'registerUser',
        'productClassification': classification,
        'customerData': customerData,
        'product': product,
        'coupon': coupon
      }
    );
  }

  public promoteUser(businessId: string, userId: string, validationCode: string, classification: string) {
    return this.httpService.post(
      this.CHECK_AND_VALIDATE,
      Api.One_Portal,
      {
        'identifier': 'promote',
        'productClassification': classification,
        'customerData': {
          'businessId': businessId,
          'userId': userId,
          'validationCode': validationCode,
          'email': this.currentCustomerdata && this.currentCustomerdata.email ? this.currentCustomerdata.email : ''
        }
      });
  }

  public getContractStatusByProvisioningParameters(businessId: string, userId: string, productClassification: string): Observable<any>{
    return this.httpService.post(
      "eCommercePME/eCommerceAPI/getContractStatusByProvisioningParameters", 
      Api.One_Portal, 
      {
        "businessId": businessId,
        "userId": userId,
        "productClassification": productClassification
    });
  }
}